import {
  RETRIEVE_INBOUND_POSTAL_OPERATOR_FAILURE,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST,
  RETRIEVE_INBOUND_POSTAL_OPERATOR_SUCCESS,
  ARRIVAL_MAIL_PROCESSING_CENTER_CHECKED,
  ARRIVAL_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS,
  DESELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_ARRIVAL_OPERATORS,
  DESELECT_ALL_ARRIVAL_OPERATORS,
} from './types/ArrivalPostalOperatorActionTypes';

export function retrieveInboundPostalOperatorsRequestActionCreator(
  payload,
  reportDefinition,
  arrivalCheckedMailProcessingCenters,
) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST,
    payload,
    reportDefinition,
    arrivalCheckedMailProcessingCenters,
  };
}

export function retrieveInboundPostalOperatorsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_SUCCESS,
    payload,
  };
}

export function retrieveInboundPostalOperatorsFailureActionCreator(error) {
  return {
    type: RETRIEVE_INBOUND_POSTAL_OPERATOR_FAILURE,
    error,
  };
}

export function arrivalMailProcessingCenterCheckedActionCreator(
  checkedMailProcessingCenters,
  reportDefinition,
) {
  return {
    type: ARRIVAL_MAIL_PROCESSING_CENTER_CHECKED,
    checkedMailProcessingCenters,
    reportDefinition,
  };
}

export function onArrivalPostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: ARRIVAL_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onSelectAllArrivalMailProcessingCenters(nodes) {
  return {
    type: SELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS,
    payload: {
      nodes,
    },
  };
}

export function onSelectAllArrivalOperators(nodes) {
  return {
    type: SELECT_ALL_ARRIVAL_OPERATORS,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllArrivalMailProcessingCenters() {
  return {
    type: DESELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS,
  };
}

export function onDeSelectAllOperators() {
  return {
    type: DESELECT_ALL_ARRIVAL_OPERATORS,
  };
}
